module.exports = __webpack_public_path__ + "img/565.6f27c680.jpg";